import React, { useEffect, useRef, useState } from 'react';
import { Bell } from 'lucide-react';
import { Button } from './ui/button';
import { setPushExplainerHost } from '../lib/pushPermission';

const COPY = {
    first_save: {
        title: 'Want a nudge to come back to this?',
        body: "Turn on notifications and we'll remind you when it's time to revisit what you saved.",
    },
    reminder: {
        title: 'Want this reminder to reach you?',
        body: "Turn on notifications so we can ping you when it's due, even when BrainSync is closed.",
    },
    default: {
        title: 'Want a nudge to come back to your saves?',
        body: "Turn on notifications and we'll remind you when it's time to revisit what you saved.",
    },
};

export function PushPermissionPrompt() {
    const [context, setContext] = useState(null);
    const resolver = useRef(null);

    useEffect(() => {
        setPushExplainerHost((ctx) => new Promise((resolve) => {
            resolver.current = resolve;
            setContext(ctx || 'default');
        }));
        return () => setPushExplainerHost(null);
    }, []);

    const answer = (accepted) => {
        resolver.current?.(accepted);
        resolver.current = null;
        setContext(null);
    };

    if (!context) return null;
    const copy = COPY[context] || COPY.default;

    return (
        <div className="fixed inset-x-0 bottom-0 z-[70] p-4 flex justify-center pointer-events-none" data-testid="push-explainer">
            <div className="pointer-events-auto w-full max-w-md bg-background rounded-2xl border border-border shadow-2xl p-5 animate-in slide-in-from-bottom-4 fade-in duration-300">
                <div className="flex items-start gap-3">
                    <div className="shrink-0 w-10 h-10 rounded-xl bg-[#2E3A2F] text-white flex items-center justify-center">
                        <Bell className="w-5 h-5" />
                    </div>
                    <div className="min-w-0">
                        <p className="font-semibold text-base leading-snug" data-testid="push-explainer-title">{copy.title}</p>
                        <p className="text-sm text-muted-foreground mt-1">{copy.body}</p>
                    </div>
                </div>
                <div className="flex justify-end gap-2 mt-4">
                    <Button variant="ghost" onClick={() => answer(false)} data-testid="push-explainer-later">Not now</Button>
                    <Button onClick={() => answer(true)} data-testid="push-explainer-accept">Turn on</Button>
                </div>
            </div>
        </div>
    );
}
